import { Select, InputLabel, MenuItem, FormControl, FormHelperText } from "@mui/material"
import { makeStyles } from "@mui/styles";
import { AppColors } from "resources/AppColors";

const useStyles = makeStyles((theme) => ({
  textFieldLabel: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: AppColors.PRIMARY,
      },
    },
    "& .MuiInputBase-root": {
      color: AppColors.PRIMARY,
    },
    "& .MuiInputLabel-root": {
      color: AppColors.PRIMARY,
    },
    color: AppColors.PRIMARY,
    backgroundColor: AppColors.BOX_FILL,
  },
}));

function SingleChoiceDropdown({ label, value, handleValue, items, required, labelRequired, error, isScheduledForm, ...other }) {
  const classes = useStyles();

  return (
    <>
      <FormControl
        sx={{ minWidth: 300, mt: 2 }}
        required={required}
        className={classes.textFieldLabel}
      >
        <InputLabel
          className={classes.textFieldLabel}
          id="single-choice-dropdown"
          required={labelRequired}
        >
          {label}
        </InputLabel>
        <Select
          labelId="single-choice-select-label"
          id="single-choice-select"
          value={value}
          label={label}
          onChange={handleValue}
          className={classes.textFieldLabel}
          error={Boolean(error)}
          data-cy="single-choice-dropdown"
          {...other}
        >
          {items.map((item, i) =>
            <MenuItem
              key={item.value}
              value={isScheduledForm ? item.slug : item.value}
              data-cy={`single-choice-dropdown-item-${i}`}
            >
              {item.name}
            </MenuItem>
          )}
        </Select>
        <FormHelperText
          id="my-helper-text"
          error={true}
        >
          {Boolean(error) ? error?.message : ""}
        </FormHelperText>
      </FormControl>
    </>
  )
}

export default SingleChoiceDropdown